import React from "react";
import CurrencyFormatInput from "../../../commonComponents/util/CurrencyFormatInput";
import Modal from "../../../commonComponents/util/Modal";
import RadioGroup from "../../../commonComponents/util/RadioGroup";

import ValidatedInput from "../../../commonComponents/util/ValidatedInput";
import { TransactionTypes } from "../../../../lib/constants";
import _cloneDeep from "lodash.clonedeep";

const initialState = {
  adjustment: {
    amount: "",
    description: "",
    transactionType: TransactionTypes.Deposit
  },
  submitAttempted: false
};

export default class ReconciliationAdjustmentModal extends React.Component {
  state = _cloneDeep(initialState);

  componentWillUpdate(nextProps) {
    if (nextProps.show && !this.props.show && nextProps.adjustment) {
      const {
        adjustment: { amount, description, transactionType }
      } = nextProps;

      this.setState({
        adjustment: {
          amount,
          description: description || "",
          transactionType
        },
        submitAttempted: false
      });
    }
  }

  save = async () => {
    this.setState({ submitAttempted: true });

    const { adjustment } = this.state;
    if (
      !adjustment.amount ||
      !adjustment.transactionType
    ) {
      return;
    }

    this.props.submit(adjustment);
    this.close();
  };

  close = () => {
    this.setState(initialState, this.props.close);
  };

  onChange = (name, value) => {
    this.setState({
      adjustment: {
        ...this.state.adjustment,
        [name]: value
      }
    });
  };

  render() {
    const { adjustment: adjustmentEdit, isIsraeli, show } = this.props;
    const { adjustment, submitAttempted } = this.state;

    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal new-transaction-modal large-modal">
            <div className="bordered-modal-header">
              <h4 className="page-header">
                {adjustmentEdit ? "Edit" : "New"} Reconciliation Adjustment
              </h4>
              <i className="icon ion-ios-close-empty" onClick={this.close} />
            </div>
            <div className="modal-section">
              <RadioGroup
                name="transactionType"
                title="Transaction Type"
                value={adjustment.transactionType}
                options={[
                  {
                    key: TransactionTypes.Deposit,
                    value: TransactionTypes.Deposit
                  },
                  {
                    key: TransactionTypes.Withdrawal,
                    value: TransactionTypes.Withdrawal
                  }
                ]}
                onChange={this.onChange}
              />
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedInput
                    input={<CurrencyFormatInput isIsraeli={isIsraeli} />}
                    name="amount"
                    value={adjustment.amount}
                    onChange={this.onChange}
                    required={true}
                    showRequiredError={submitAttempted}
                    label="Amount"
                  />
                </div>
                <div className="column-half">
                  <label className="input-label">Description</label>
                  <input
                    name="description"
                    onChange={e => this.onChange(e.target.name, e.target.value)}
                    type="text" 
                    value={adjustment.description}
                  />
                </div>
              </div>
            </div>
            <div className="modal-btns text-right">
              <button className="btn btn-accent" onClick={this.close}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={this.save}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/ReconciliationAdjustmentModal.jsx